import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";
export const SocialData = [
  { name: "Visit Facebook", icon: FaFacebookF },
  { name: "Visit Youtube", icon: FaYoutube },
  { name: "Visit Instagram", icon: FaInstagram },
];

export const CardData = [
  {
    title: "Student Reward",
    content: " Click to go student reward program",
  },
  {
    title: "Notice",
    content:
      " We are open seven days a week So Come Fast We are open seven days a week So Come Fast We are open seven days a week So Come Fast",
  },
  {
    title: "Poll",
    content: " Click to go student reward program",
  },
  {
    title: "Vote For Movie",
    content:
      " Click to go student reward program Click to go student reward program Click to go student reward program",
  },
  {
    title: "Recent",
    content: " Click to go student reward program  ",
  },
];
